export const fmtDate = (s) => {
  if (!s) return '';
  try {
    return new Date(s).toLocaleString('en-IN', { dateStyle: 'medium', timeStyle: 'short' });
  } catch {
    return s;
  }
};

export const fmtTimeAgo = (s) => {
  if (!s) return '';
  const ms = Date.now() - new Date(s).getTime();
  const h = Math.floor(ms / 3600000);
  if (h < 1) return 'just now';
  if (h < 24) return `${h}h ago`;
  const d = Math.floor(h / 24);
  return `${d}d ago`;
};

export const whatsappLink = (cart) => {
  if (!cart.phone) return null;
  const phone = cart.phone.replace(/\D/g, '');
  const items = cart.items.map(i => `• ${i.product_name} x${i.quantity}`).join('\n');
  const msg = encodeURIComponent(
    `Hi ${cart.name || 'there'}! Noticed you left some items in your Sanatanbhavan cart:\n\n${items}\n\nTotal: ₹${cart.total}\n\nWould you like to complete your purchase?`
  );
  return `https://wa.me/91${phone}?text=${msg}`;
};
